var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTurnRightCanvas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFF;stroke:#FFF;stroke-width:1.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,12) scale(0.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,72.1V42.7c0,0,0-1.7,0.2-2.6c0.1-0.9,0.3-1.9,0.5-2.8c0.6-2.6,1.7-5,3.1-7.2c0.9-1.4,1.9-2.6,3-3.8 c0.2-0.2,0.5-0.5,0.8-0.7c0.2-0.2,0.5-0.5,0.8-0.7c0.4-0.3,0.8-0.7,1.3-1c0.2-0.1,0.4-0.2,0.5-0.4c0.8-0.6,1.7-1.1,2.6-1.5 c0.3-0.2,0.6-0.3,1-0.5s0.9-0.4,1.3-0.5c0.8-0.3,1.6-0.6,2.4-0.8l0,0c0.6-0.2,1.3-0.3,1.9-0.4c1.2-0.2,2.4-0.3,3.7-0.3l9.7,0.1V7.9 l18.8,18.6L47,45.2l-0.2-11.3l-9,0c-4,0-7.4,2.4-8.7,5.9c-0.2,0.5-0.4,1-0.5,1.6c0,0,0,0.1,0,0.2c-0.1,0.6-0.2,1.2-0.2,1.8l0,0.1 c0,0.5,0,0.9,0,1.4v27.2H14.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTurnRightCanvas);
export default __webpack_public_path__ + "static/media/arrow-turn-right-canvas.d722aee89f34c513c2b626c18f1f5ada.svg";
export { ForwardRef as ReactComponent };